interface AuthConfig {
  domain: string;
  clientId: string;
  audience: string;
}

/**
 * Configuração de autenticação baseada em variáveis de ambiente
 *
 * Todas as configurações são carregadas dinamicamente das variáveis
 * de ambiente, permitindo flexibilidade total por ambiente.
 */
const AuthConfig: AuthConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || "cockpit-dev.us.auth0.com",
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || "PEzFwpK7yhXKO6oyFpauDo4F0AO1Tdjl",
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || "https://d462d9b9k8.execute-api.us-east-1.amazonaws.com/"
};

export default AuthConfig;
